export const bcmeaStyles = {
  colour: {
    neutralWhite: "#FFFFFF",
    black: "#000000",
    clearBlue: "#6DC4ED",
    oceanicGreen: "#21D68F",
    offGray: "#595959",
    coldWhite: "#E3E3E3",
    forestGreen: "#019E40",
    warmBlue: "#4A8FB2",
    corporateBlue: "#05294D",
    orange: "#FFC000",
    lightClearBlue: "#B3E4F7",
  },
  fontFamily: {
    proximaNovaRegular: "ProximaNovaRegular",
    proximaNovaBold: "ProximaNovaBold",
    proximaNovaItalic: "ProximaNovaItalic",
    proximaNovaLight: "ProximaNovaLight",
    proximaNovaMedium: "ProximaNovaMedium",
    proximaNovaSemibold: "ProximaNovaSemibold",
  }
};
